import { redirect } from "@tanstack/react-router";
import { homePathFor, type Role } from "@/config/roles";
import { session } from "@/lib/auth";

/**
 * Route-level role guard for `beforeLoad`. Super Admin may enter any portal for
 * support; every other role is confined to the portals that admit it. The
 * employee portal admits the SMM too, who posts like everyone else (SB-40).
 * The API enforces the same rules server-side; this only shapes navigation.
 */
export function requireRole(...roles: Role[]) {
  const { user } = session.get();
  if (!session.isAuthenticated() || !user) {
    throw redirect({ to: "/login" });
  }
  if (!roles.includes(user.role) && user.role !== "super_admin") {
    throw redirect({ to: homePathFor(user.role) });
  }
}
